<template>
	<div class="innerBox">
        <div class="row">
            <div class="col-9">
                <h2 class="mb-4">PO Sparepart</h2>
            </div>
            <div class="col-3">
                <button class="btn btn-primary w-100" @click="$router.push({name : 'PurchaseInventoryList'})">&lt; Kembali</button>
            </div>
        </div>
		
		<div class="w-100 " style="overflow-x:scroll;min-height:600px">
			<table class="table w-100 table-bordered rounded text-center table-striped table-dark">
				<tbody>
					<!-- <tr>
						<td class="">
							<h6>Pilih Work Order</h6>
						</td>
						<td class="pl-4">
							<Multiselect 
								v-if="woList"
								class="w-50"
								:options="woList.map(x => x.form_code)"
								:custom-label="opt => woList.find(x => x.form_code == opt).col_name"
								v-model="workOrderCode.form_code"
							/>
						</td>
					</tr> -->
					<!-- <tr>
						<td>
							<h6>Pilih Pekerja</h6>
						</td>
						<td class="pl-4">
							<Multiselect 
								class="w-50"
								v-if="labourerList"
								:options="labourerList.map(x => x.id)"
								:custom-label="opt => labourerList.find(x => x.id == opt).name"
								:disabled="!workOrderCode.form_code"
								v-model="labourer"
							/>
						</td>
					</tr> -->

					<tr>
						<td colspan="2">
							<div class="row pl-4 mt-2 mb-3">
								<div class="col-md-7 col-7 text-left" style="margin-top:auto;margin-bottom:auto;">
									<h6>Daftar PO Barang {{workOrderCode.form_code}} - {{workOrderCode.car_name}} - {{workOrderCode.registration}}</h6>
								</div>
                                <!-- <div class="col-md-5 col-5 text-right">
                                    <button class="btn btn-info" :disabled="!workOrderCode.form_code" @click="showPrintModal()">Print Purchase Order</button>
                                </div> -->
								<!-- <div class="offset-md-5 offset-2 col-md-3 col-4">
									<button type="button" class="btn btn-primary w-100" disabled>Tambah Sparepart</button>
								</div> -->
							</div>
							
							<table class="table table-border text-white" v-if="estimatorSparepartData">
								<thead>
									<th>PO ID</th>
									<th>Tipe Sparepart</th>
									<th>Nama Sparepart</th>
									<!-- <th>Deskripsi</th> -->
									<th>Deskripsi Part</th>
									<th>Dipesan Oleh</th>
									
									<th>Jumlah Diperlukan</th>
									<th>Supplier</th>
									<th>Harga per Barang</th>
									<th>Waktu Diterima</th>
									<th colspan="3"><i class="fas fa-cog"></i></th>
								</thead>
								<tbody v-if="!purchaseOrderList">
									<tr>
										<td colspan="10">Mohon Pilih Nomor Work Order Terlebih Dahulu</td>
									</tr>
								</tbody>
								<tbody v-else>
                                    <template v-for="(estimatorSparepart , index) in estimatorSparepartData" >
                                        <tr>
                                            <td>
                                                {{index + 1}}
                                            </td>
                                            <td>
                                                {{estimatorSparepart.sparepart_type}}
                                            </td>
                                            <td>
                                                {{estimatorSparepart.sparepart_name}}
                                            </td>
                                            <td>
                                                {{estimatorSparepart.part_number ? estimatorSparepart.part_number : '-'}}
                                            </td>
                                            <td>
                                                {{estimatorSparepart.is_supplied_by_insurance ? estimationDetail.insuranceCompany : "Bengkel"}}
                                            </td>
                                            <td>{{estimatorSparepart.amount}}
                                            </td>
                                            <td>
                                                {{$store.getters.getSupplier.find(x => x.id == estimatorSparepart.supplier_id) ? supplierList.find(x => x.id == estimatorSparepart.supplier_id).name : 'Unregistered'}}

                                            </td>
                                            <td>Rp {{estimatorSparepart.price_per_item ? numberWithCommas(estimatorSparepart.price_per_item) : '-'}}</td>
                                            <td>{{estimatorSparepart.purchaseOrder ? estimatorSparepart.purchaseOrder.time_of_arrival ? moment(estimatorSparepart.purchaseOrder.time_of_arrival).format("DD MMM Y HH:mm") : '-' : '-'}}</td>
                                            <td v-if="estimatorSparepart.is_po">
                                                
                                                <button type="button" class="btn btn-info" v-if="!estimatorSparepart.purchaseOrder.is_arrived" @click="showUploadModal('is_arrived' , estimatorSparepart.purchaseOrder.estimation_id ,estimatorSparepart.sparepart_name , estimatorSparepart.purchaseOrder.amount , estimatorSparepart.purchaseOrder , index)">Barang Datang</button>
                                                <b class="text-blue" v-else-if="estimatorSparepart.purchaseOrder.is_used">Barang Sudah Terpakai</b>
                                                <button type="button" class="btn btn-danger" v-else-if="estimatorSparepart.purchaseOrder.is_arrived && !estimatorSparepart.purchaseOrder.is_return" @click="showUploadModal('is_return' , estimatorSparepart.purchaseOrder.estimation_id ,estimatorSparepart.sparepart_name , estimatorSparepart.purchaseOrder.amount, estimatorSparepart.purchaseOrder , index)">Retur Barang</button>
                                                <b class="text-yellow" v-else>Barang Sudah Di Retur</b>
                                            </td> 
                                            <td v-else>
                                                
                                                <button type="button" class="btn btn-danger" @click="POBarang(estimatorSparepart.id , estimatorSparepart.sparepart_id, null)">PO Barang</button>
                                            </td>
                                            <td v-if="estimatorSparepart.purchaseOrder && estimatorSparepart.purchaseOrder.barcode">
                                                <!-- {{estimatorSparepart}} -->
                                                <button type="button" class="btn btn-primary" @click="printBarcode(estimatorSparepart.purchaseOrder.barcode , estimatorSparepart.sparepart_name , estimatorSparepart.part_number , workOrderCode.form_code , estimatorSparepart.purchaseOrder.time_of_arrival)">Print Barcode</button>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-warning" @click="showImage(estimatorSparepart , index)">Lihat Gambar</button>
                                            </td>

                                        </tr>
                                        <tr v-if="estimatorSparepart.modalShow">
                                            <td colspan="15">
                                                <upload-image
                                                    :title="modal.title"
                                                    :endpoint="modal.endpoint"
                                                    :image_count="3"
                                                    :estimator="estimatorSparepart"
                                                    @onResponse="updateStatusPO"
                                                    @closeModal="estimatorSparepart.modalShow = false"
                                                ></upload-image>
                                            </td>
                                        </tr>
                                    </template>
								</tbody>
							</table>
						</td>
					</tr>

				</tbody>
			</table>
		</div>

		<!--  -->

		<preview-image
			v-if="imagePreview"
			@closeModal="imagePreview = null"
			:title="'Foto Barang - ' + modal.description"
			:image="imagePreview"
            
		></preview-image>

        <PrintPO
            v-if="modalPrint"
            @closeModal="modalPrint = false"
            :data="estimatorSparepartData"
            :workOrderDetail="woList.find(x => x.form_code == workOrderCode.form_code)"

        />

        <dpPo 
            v-if="modal.showDp"
            @closeModal="modal.showDp = false"
            @returnDP="POBarang"
            :id="modal.id"
            :sparepart_id="modal.sparepart_id"
        />


	</div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import PrintPO from './children/PrintPO'
    import moment from 'moment'
    import UploadImage from './uploadBarang.vue'
    import previewImage from './children/previewImageSpecial.vue'
    import dpPo from './children/dpPo.vue'
    import env from '@/env'

    export default {
        data() {
            return {
                estimatorSparepartData: null,
                estimationDetail : null,
                woList: null,
                workOrderCode : this.$route.params.workOrderCode,
                labourer: null,
                reloadTable: false,
                labourerList: null,
                purchaseOrderList: null,
                imagePreview: null,
                moment,
                savedData: {
                    status: null,
                    estimation_id: null,
                    name: null,
                    amount: null,
                    purchaseOrder: null,
                    delivery_photo: null,
                    index : null
                },
                modal: {
                    show: false,
                    title: '',
                    endpoint: env.urlStart + '/api/v1/workorder/steps/upload',
                    description : '',
                    showDp : false,
                    sparepart_id : null,
                    id : null
                },
                modalPrint : false,
                index : null,
                supplierList : []
            }
        },
        components: {
            Multiselect,
            UploadImage,
            previewImage,
            PrintPO,
            dpPo
        },
        mounted() {
            this.workOrderCode = JSON.parse(this.workOrderCode)
            // this.getListOfLabourer()
            // this.getListOfWorkOrder()
            this.getEstimationDetails()
            this.loadSupplierList()
        },
        methods: {
            loadSupplierList () {
                this.$http.get('/api/v1/masterData/supplier?pagination=false')
                .then((resp) => {
                    this.supplierList = resp.data.data
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            printBarcode (barcode , name , part_number , form_code , time_of_arrival) {
                this.$http({
                    url : '/api/v1/workorder/print/printDoc',
                    method : 'post',
                    data : {
                        type : 'printPO',
                        data : {
                            barcode : barcode,
                            name : name , 
                            part_number : part_number , 
                            form_code : this.workOrderCode,
                            time_of_arrival,
                            insurance : this.estimationDetail.insuranceCompany
                        }
                    }
                }).then((resp) => {
                    let data = resp.data.data
                    console.log(data)
                    var prntWin = window.open("");
                    prntWin.document.write("<html><head><title>"+name+"</title></head><body>" + 
                    '<iframe width="100%" height="100%" name="plugin" src="'+env.baseImage + '/' + data+'"></iframe></body></html>');
                    this.reason = null

                    // prntWin.print();
                    // this.getKwitansiCounter()
                    this.printing = false

                    
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            showImage(estimasi , index) {
               if(!estimasi.purchaseOrder.delivery_photo) {
                   this.$store.dispatch('triggerAlert' , [false , 'Barang Belum Datang']);
                   return
               }

               this.modal.description = estimasi.part_number

            //    this.index = index
               
               this.imagePreview = estimasi.purchaseOrder.delivery_photo.split(',')


            },
            // getListOfWorkOrder () {
            //     this.woList = null;
            //     this.$http.get('api/v1/workorder/listing/ongoing-purchasing')
            //     .then((resp) => {
            //         this.woList = resp.data.data[0]

            //         for(var i = 0; i < this.woList.length; i++) {
            //             console.log(this.woList[i].car_name)
            //             this.woList[i].col_name = this.woList[i].form_code + ' - ' + this.woList[i].registration + ' - ' + this.woList[i].car_name
            //         }
            //     })
            //     .catch((err) => { console.log(err) })
            // },
            showPrintModal() {
                this.modalPrint = true
            },
            showUploadModal(status, estimation_id, name, amount, purchaseOrder , index) {
                this.savedData.status = status
                this.savedData.estimation_id = estimation_id
                this.savedData.name = name
                this.savedData.amount = amount
                this.savedData.purchaseOrder = purchaseOrder
                this.modal.title = status == 'is_arrived' ? 'Unggah Foto Penerimaan Barang' : 'Unggah Foto Retur Barang'
                this.estimatorSparepartData.map(x => x.modalShow = false)
                this.estimatorSparepartData[index].modalShow = !this.estimatorSparepartData[index].modalShow
               
                this.savedData.index = index
                // this.modal.show = true
            },
            async getSupplierEstimator() {
                try {
                    let response = await this.$http.get('/api/v1/estimations-supplier/' + this.workOrderCode.form_code)

                    return response.data.data
                } catch (err) {
                    console.log(err)
                }

            },
            POBarang(id, sparepart_id, dp) {
                // // console.log(dp)
                // this.$store.dispatch('triggerAlert' , [false , 'Process PO Barang Di Nonaktifkan. Mohon Print PO Di Estimator Terlebih Dahulu.'])
                // return

                if(typeof dp != 'number') {
                    this.modal.showDp = true
                    this.modal.sparepart_id = sparepart_id
                    this.modal.id = id
                    return
                }

                let data = {
                    estimation_id: id,
                    sparepart_id: sparepart_id,
                    dp : dp
                }

                console.log(data)

                this.$http.post('/api/v1/purchase-order/' + this.workOrderCode.form_code, [data])
                .then((resp) => {
                    // console.log(resp.data.data)
                    this.getEstimationDetails()
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            updateStatusPO(image , time , espObj) {
                console.log(time)
                let data = {
                    estimation_id: this.savedData.estimation_id,
                    delivery_photo: image,
                    time_of_arrival : time,
                    barcode : `5${String(this.savedData.estimation_id).padStart(10 , 0)}`,
                    supplier : espObj.supplier
                }
                
                espObj.price_per_item ? data.price_per_item = parseInt(espObj.price_per_item) : ''
                if(espObj.ppn_included) {
                    if(espObj.ppn_included == 'without_ppn'){
                        data.ppn_included = false
                        data.without_ppn = true
                    }
                    else {
                        data.ppn_included = espObj.ppn_included
                    }
                }

                data[this.savedData.status] = true

                this.$http.patch('/api/v1/purchase-order/' + this.workOrderCode.form_code, data)
                    .then((resp) => {
                        console.log(this.savedData)
                        let message = this.savedData.status == 'is_arrived' ? `Barang ${this.savedData.name} telah diterima` : `Barang ${this.savedData.name} telah diretur`
                            // this.$store.dispatch('triggerAlert', [true, [`Barang ${this.savedData.name} telah diterima`]]);


                        this.getPurchaseOrderDetails()
                        let price = parseFloat(this.savedData.purchaseOrder.supplierDetails[0] ? this.savedData.purchaseOrder.supplierDetails[0].price_per_item * this.savedData.purchaseOrder.amount : 0)
                        this.savedData.amount = parseFloat(this.savedData.purchaseOrder.amount) * (this.savedData.status == 'is_arrived' ? 1 : -1)
                        

                        // let descDatang = `Hutang Pembelian Sparepart ${this.savedData.name} Untuk WO ${this.workOrderCode.form_code} Pada ${!this.savedData.purchaseOrder.supplierDetails[0] ? 'Asuransi' : 'Supplier ' +this.$store.getters.getSupplier.find(x => x.id == this.savedData.purchaseOrder.supplierDetails[0].supplier_id).name}`
                        // let descRetur = `Pembatalan Hutang Pembelian Sparepart ${this.savedData.name} Untuk WO ${this.workOrderCode.form_code} Pada ${!this.savedData.purchaseOrder.supplierDetails[0] ? 'Asuransi' : 'Supplier ' +this.$store.getters.getSupplier.find(x => x.id == this.savedData.purchaseOrder.supplierDetails[0].supplier_id).name}`
                        let dataInventory = {
                            sparepart_id: this.savedData.purchaseOrder.sparepart_id,
                            // price_per_item: price + parseFloat(this.savedData.purchaseOrder.supplierDetails[0].markup),
                            price_per_item : 0,
                            amount: this.savedData.amount,
                            workorder_code: this.workOrderCode.form_code,
                            status : this.savedData.status,
                            // accountTransaction : [{
                            //     type : 'Markup Inventory',
                            //     amount : parseFloat(this.savedData.purchaseOrder.supplierDetails[0].markup),
                            //     debit_credit : this.savedData.status == 'is_arrived' ? 1 : -1,
                            //     description : `${this.savedData.status == 'is_arrived' ? 'Penambahan' : 'Pembatalan'} Harga Markup Sparepart ${this.savedData.name} Pada WO ${this.workOrderCode.form_code}`
                            // },{
                            //     type : 'Account Payable',
                            //     amount : price,
                            //     debit_credit : this.savedData.status == 'is_arrived' ? 1 : -1,
                            //     description : this.savedData.status == 'is_arrived' ? descDatang : descRetur
                            // }],

                            transaction_description: `Purchase Order ${this.savedData.name} ${this.savedData.status == 'is_arrived' ? 'Konfirmasi Barang Datang' : 'Konfirmasi Barang Retur'}`
                        }
                        // console.log(dataInventory)
                        this.$http.post('/api/v1/inventory', dataInventory)
                            .then((resp) => {
                                // console.log(resp.data.data)
                                this.$store.dispatch('triggerAlert', [true, `Purchase Order ${this.savedData.name} ${this.savedData.status == 'is_arrived' ? 'Konfirmasi Barang Datang' : 'Konfirmasi Barang Retur'}`])
                                // this.modal.show = false
                                this.estimatorSparepartData[this.savedData.index].modalShow = false
                                this.getEstimationDetails()
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            getEstimationDetails() {
                this.estimatorSparepartData = null;
                this.$http.get('/api/v1/workorder-estimation/' + this.workOrderCode.form_code)
                    .then(async(resp) => {
                        // this.estimatorSparepartData = resp.data.data.estimations
                        let estimations = resp.data.data.estimations
                        this.estimationDetail = resp.data.data.details
                        let data = []
                        this.estimation_id = resp.data.data.details.id
                            // console.log(estimations)

                        let listOfPO = await this.getPurchaseOrderDetails()
                        let supplierList = await this.getSupplierEstimator()

                        for (var i = 0; i < estimations.length; i++) {
                            // console.log(estimations[i])
                            estimations[i].amount = parseFloat(estimations[i].amount)
                                // console.log(estimations[i].sparepart_type ,  estimations[i].is_approved_by_insurance)
                            if ((estimations[i].sparepart_type == 'P') && estimations[i].is_approved_by_insurance) {
                                let poDetails = listOfPO.find(x => x.estimation_id == estimations[i].id && !x.next_purchase_order_item)
                                let supplierListEstimation = supplierList.find(x => x.estimations_id == estimations[i].id)
                                if (supplierListEstimation) {
                                    let supplier = supplierListEstimation.supplier_prices.find(x => x.id == estimations[i].supplier_price_id)
                                    estimations[i].supplier_id = supplier ? supplier.supplier_id : null
                                    estimations[i].supplierDetails = supplier
                                }
                                if (poDetails) {
                                    estimations[i].is_po = true
                                        // estimations[i].is_used = poDetails.is_used
                                        // estimations[i].is_arrived = poDetails.is_arrived
                                    estimations[i].purchaseOrder = poDetails

                                } else {
                                    estimations[i].is_po = false
                                }

                                // if(estimations[i].is_po == false &&  estimations[i].is_supplied_by_insurance)
                                //     this.POBarang(estimations[i].id , estimations[i].sparepart_id)

                                estimations[i].modalShow = false



                                data.push(estimations[i])
                                    // console.log(estimations[i])
                            }

                        }
                        this.estimatorSparepartData = data
                            // console.log(this.estimatorSparepartData)
                            // this.getPurchaseOrderDetails()

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            async getPurchaseOrderDetails() {
                this.purchaseOrderList = null
                let result = await this.$http.get('/api/v1/purchase-order/' + this.workOrderCode.form_code)

                let data = result.data.data
                this.purchaseOrderList = []

                for (var i = 0; i < data.length; i++) {
                    if (data[i].part_number) {
                        // data[i].sparepartDetails = await this.findSparepartDetails(data[i].sparepart_id)

                        this.purchaseOrderList.push(data[i])
                    }

                }



                // this.purchaseOrderList = this.$set({} , this.purchaseOrderList , purchaseList)
                this.reloadTable = true
                this.reloadTable = false
                return this.purchaseOrderList

            },
            async findSparepartDetails(id) {

                let queryParam = "k=Spareparts.id&c==&v=" + id

                let data = null

                let result = await this.$http.get('/api/v1/inventory?' + queryParam)

                data = result.data.data.results[0]

                return data
            },
            
            getListOfLabourer() {
                this.labourerList = null

                this.$http.get('/api/v1/masterData/labourer?pagination=false')
                    .then((resp) => {
                        this.labourerList = resp.data.data
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }
</script>

<style scoped>
    .table td {
        vertical-align: middle;
    }
    
    .middleMargin {
        margin-top: auto;
        margin-bottom: auto;
    }
</style>